















import {Component, Prop, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import RiskAreaRequest from '@/model/request/RiskAreaRequest'

@Component
export default class FilterRiskArea extends Mixins(MixinMember) {
  @Prop({required: true}) value!: RiskAreaRequest
}
